import { Component } from "@angular/core";
import { EceButtonComponent } from "./ece.button.component";

@Component({
    selector: "ece-btn-sort",
    templateUrl: "./ece.button.component.html",
    standalone: false
})
export class SortButtonComponent extends EceButtonComponent {
  icon = "sort-asc";
}
